import { gql } from "@apollo/client";

export const Qualification_Record_Query = gql`
query M_Qualification($validate: Boolean, $active: Boolean, $id: uuid,$qid: uuid) {
  aatmsv4_qualificationrecords(order_by: {qualification: asc, validdate: asc}, where: {active: {_eq: $active}, clientsid: {_eq: $id}, validated: {_eq: $validate}, qid: {_eq: $qid}}) {
    crew {
      ecode
      name
      fleetsid
      fleet {
        aircraft
      }
    }
    qrid
    qcode
    documentnumber
    issuedate
    validdate
    validated
  }
}
`

export const Fetch = gql`
query M_Qualification{
    aatmsv4_qualificationrecords(order_by: {qualification: asc,validdate: asc}, where: {active: {_eq: true}, validated: {_eq: true}}) {
    crew {
    ecode
    name
    fleetsid
    fleet {
    aircraft
    }
    }
   qrid
   qcode
    documentnumber
    issuedate
    validdate
    validated
    }
   }
`
export const Fetches = gql`
query M_Qualification{
    aatmsv4_qualificationrecords(order_by: {qualification: asc,validdate: asc}, where: {active: {_eq: false}, validated: {_eq: true}}) {
    crew {
    ecode
    name
    fleetsid
    fleet {
    aircraft
    }
    }
   qrid
   qcode
    documentnumber
    issuedate
    validdate
    validated
    }
   }
`
export const Qualification_View_Query = gql`
query M_Qualification_View(
    $id: uuid
){
 aatmsv4_qualificationrecords(where: {qrid: {_eq: $id}}) {
 crew {
 ranksid
 rank {
 rank
}
 name
 ecode
 fleetsid
 fleet {
 aircraft
}
}
 qcode
 qualification
 documentnumber
 issuingauthority
 caption1
 data1
 caption2
 data2
 caption3
 data3
 category
 subcategory
 issuedate
 validdate
 manager {
 managername
}
 managerByManagersid1 {
 managername
}
 managerByManagersid2 {
 managername
}
 validated
 active
 document
}
}
`
export const Update_Qualification = gql`
mutation M_Qualifiation_Edit(
    $id: uuid
    $active: Boolean
    $valid: Boolean
    $date: date
    $date2: date
    $document: String
    $issue: String
    $data1: String
    $data2: String
    $data3: String
) {
    update_aatmsv4_qualificationrecords(where: {qrid: {_eq: $id}},
    _set: {documentnumber: $document,
    issuingauthority: $issue,
    data1: $data1,
    data2: $data2,
    data3: $data3,
    issuedate: $date,
    validdate: $date2,
    validated: $valid,
    active: $active
}) {
    returning {
    documentnumber
    issuingauthority
    data1
    data2
    data3
    issuedate
    validdate
    validated
    active
    }
    }
   }
`
export const Update_deactivate_Qualification = gql`
mutation M_Qualifiation_Edit(
    $id: uuid
    $active: Boolean
    $valid: Boolean
    $date: date
    $date2: date
    $document: String
    $issue: String
    $data1: String
    $data2: String
    $data3: String
) {
    update_aatmsv4_qualificationrecords(where: {
    qrid: {_eq: $id}},
    _set: {documentnumber: $document,
    issuingauthority: $issue,
    data1: $data1,
    data2: $data2,
    data3: $data3,
    issuedate: $date,
    validdate: $date2,
    validated: $valid,
    active: false}) {
    returning {
    documentnumber
    issuingauthority
    data1
    data2
    data3
    issuedate
    validdate
    validated
    active
    }
    }
   }
`
export const Qualification_Run = gql`
mutation M_update_qRecords(
    $dates: date
) {
    update_aatmsv4_qualificationrecords(where: {validdate: {_lte: $dates}},
   _set: {active: false}) {
    returning {
    crew {
    name
    }
    qcode
    documentnumber
    validdate
    }
    }
   }
`
export const Add_Qualifications = gql`
query M_qualification_add1(
    $id: uuid
) {
    aatmsv4_qualifications(order_by: {qcode: asc}, where: {active:{_eq: true},
    clientsid: {_eq: $id}}) {
    qid
    qcode
    qualification
    category
    subcategory
    caption1
    caption2
    caption3
    clientsid
    clientname
    managersid1
    managersid2
    managersid3
    validity
    }
   }
`
export const catagory = gql`
    query MyQuery {
        aatmsv4_category {
        categoryid
        }
    }
`
export const subcatagory = gql`
query da_subcategories {
    aatmsv4_subcategory {
      subcategoryid
    }
  }
`
export const getClientId = gql`
query login(
    $id: String
) {
  aatmsv4_users(where: {userid: {_eq: $id}}) {
    client {
      clientname
      clientsid
    }
  }
}
`
export const get_Crew_Fleets = gql`
query M_qualification_add2(
    $id: uuid
) {
    aatmsv4_crews(order_by: {name: asc}, where: {active: {_eq: true}, clienstid: {_eq: $id}}) {
      name
      crewid
      fleet {
        aircraft
      }
    }
  }
`
export const exist_Qualification = gql`
query M_qualification_add3(
    $crewId: String
    $id: uuid
) {
    aatmsv4_qualificationrecords(where: {qid: {_eq: $id}, _and: {active: {_eq: true}, _and: {crewid: {_eq: $crewId}}}}) {
    crew {
    name
    crewid
    fleet {
    aircraft
    }
    }
    documentnumber
    validdate
    document
    qid
    qrid
    }
   }
`
export const Qualification_false = gql`
mutation MyMutation(
    $id: uuid
) {
    update_aatmsv4_qualificationrecords(where: {qrid: {_eq: $id}}, _set: {active: false}) {
    returning {
    qrid
    qualification
    active
    }
    }
}
`
export const AllQualificationQuery = gql`
query MyQuery(
    $clientid: uuid
    $id: uuid
) {
    aatmsv4_qualifications(where: {qid: {_eq: $id}, clientsid: {_eq: $clientid}}) {
      qcode
      qid
      qualification
      managersid1
      managersid2
      managersid3
      validity
      subcategory
      caption1
      caption2
      caption3
      category
      active
      clientname
      clientsid
      cost
    }
  }
`
export const Add_Qualify = gql`
mutation M_qualification_add4(
    $id: uuid
    $clientname: String
    $crewId: String
    $data1: String
    $data2: String
    $data3: String
    $catagory: aatmsv4_category_enum
    $SubCatagory: aatmsv4_subcategory_enum
    $manager1: String
    $manager2: String
    $manager3: String
    $qcode: String
    $qid : uuid
    $qualification : String
    $caption1: String
    $caption2: String
    $caption3: String
    $documentNumber: String
    $issueAuthority: String
    $issuedate: date
    $expirydate: date
    $document: String
) {
insert_aatmsv4_qualificationrecords(objects: {clientsid: $id, clientsname: $clientname, crewid:$crewId, caption1: $caption1, caption2: $caption2, caption3: $caption3, 
category: $catagory, subcategory:$SubCatagory, managersid1: $manager1, managersid2: $manager2, managersid3:$manager3, qcode: $qcode, qid: $qid, qualification: $qualification,
documentnumber: $documentNumber, issuingauthority: $issueAuthority, data1: $data1, data2: $data2, data3: $data3,
issuedate: $issuedate, validdate: $expirydate, document: $document, active: true, validated:true}) {
    returning {
    active
    clientsname
    documentnumber
    qualification
    qid
    validdate
    document
    crew {
    crewid
    name
    fleet {
    aircraft
    }
    }
    }
    }
   }
`
export const Add_Qualify_Replace = gql`
mutation MyMutation(
    $id: uuid
    $documentNumber: String
    $issueDate: date
    $validDate: date
    $issueAuthority: String
    $data1: String
    $data2: String
    $data3: String
    $document: String
) {
    update_aatmsv4_qualificationrecords(where: {qrid: {_eq: $id}}, _set: {documentnumber: $documentNumber, issuedate: $issueDate, validdate: $validDate, issuingauthority: $issueAuthority, data1: $data1, data2: $data2, data3: $data3, document: $document}) {
      returning {
        data1
        data2
        data3
        qrid
        issuingauthority
        issuedate
        documentnumber
      }
    }
  }
`
export const managerQualifications = gql`
query MyQuery(
  $id: String
) {
  aatmsv4_qmap(where: {managersid: {_eq: $id}}) {
    qualification {
      qid
      qcode
      qualification
    }
  }
}
`